<template>
  <b-button
    @click="
      () => {
        modalState = true;
      }
    "
    size="sm"
    :disabled="disabled"
    :variant="httpRequestInProgress ? 'success' : 'primary'"
    block
    ><!-- button -->
    <span v-if="httpRequestInProgress">
      <b-spinner type="grow" label="Loading..." small />
    </span>
    <span v-else>Storno <span v-if="authorization?.dev">[REFUND: 3]</span></span>
    <b-modal
      v-model="modalState"
      id="modal-unfreeze-order"
      title="Erstatten"
      size="md"
      @hidden="
        () => {
          this.modalState = false;
        }
      "
      ><!-- modal -->
      <!-- @ok="submit()"
            cancel-title="abbrechen" -->
      Diese Bestellung wirklich erstatten?

			<div class="my-3">
				<label class="form-label">Soll beim alten Lieferanten storniert werden?</label>
				<b-form-checkbox
						v-model="shouldCreateVendorCancellation"
						:value="true"
						:unchecked-value="false">
				</b-form-checkbox>
			</div>
      <template #modal-footer>
        <div class="w-100">
          <b-btn
            centered
            size="md"
            class="float-right mx-1"
            variant="danger"
            @click="submit()"
            >Erstatten</b-btn
          >
          <b-btn
            size="md"
            class="float-right"
            variant="secondary"
            @click="
              () => {
                this.modalState = false;
              }
            "
            >Abbrechen</b-btn
          >
        </div>
      </template>
    </b-modal>
		<modal-error-component v-model="modalError"></modal-error-component>
  </b-button>
</template>
<script>
import ModalErrorComponent from "../ModalErrorComponent.vue";
import {useCustomerOrderActions} from "../../composables/useCustomerOrderActions";

export default {
	components: {ModalErrorComponent},
  props:
  {
		customerOrder: {
			type: Object,
			required: true,
		},
		orderStates: {
			type: Object,
			required: true,
		},
		authorization: {
			type: Object,
			required: false,
		},
		isOrderResponseAction: {
			type: Boolean,
			required: false,
			default: false,
		},
		vendorCancellationQuantity: {
			type: Number,
			required: false,
			default: 1,
		},
	},
  data() {
    return {
      modalState: false,
      httpRequestInProgress: false,
      unrefundableMarketAccountIds: [3, 12, 17, 26, 27, 28, 38, 39, 40, 1040], // marketplaces which do not allow refunding stuff // FNAC, Cdiscount, Worten, Bol, Rakuten
			shouldCreateVendorCancellation: false,
			modalError: {
				show: false,
				message: '',
				error: '',
				title: ''
			},
    };
  },
  computed: {
    disabled: function () {
      // if we are not in WAIT or OPEN, disable button.
      //if([this.orderStates.codes.WAIT, this.orderStates.codes.OPEN].includes(this.customerOrder.orderState)) return true;
      if (
        this.unrefundableMarketAccountIds.includes(
          this.customerOrder.marketAccountId
        )
      )
        return true;

      if (this.customerOrder.isMarketplaceMultiorder) return true;

      let delivery_submitted_to_marketplace = false;
      for (let history of this.customerOrder.customerorderhistories) {
        if (history.lastUpdateReason.includes("Delivery Job")) {
          delivery_submitted_to_marketplace = true;
          break;
        }
      }

      // if it's prime its disabled as well, only via "erstatten o.M" refundable
      if([4,5,6,8,9].includes(this.customerOrder.shippingType)){
				return true
      }

      //Button is enabled if: (State is WAIT or OPEN) AND NOT delivery_submitted_to_marketplace
      // ([this.orderStates.codes.WAIT, this.orderStates.codes.OPEN].includes(this.customerOrder.orderState) && !delivery_submitted_to_marketplace)
      // --> Invert this for disabled property


      if(this.isOrderResponseAction){
      	return delivery_submitted_to_marketplace
      } else {
				return !(
						[this.orderStates.codes.WAIT, this.orderStates.codes.OPEN, this.orderStates.codes.NEW, this.orderStates.codes.IN_PROGRESS].includes(
								this.customerOrder.orderState,
						) && !delivery_submitted_to_marketplace
				);
      }
    },
  },
  methods: {
    submit() {
      const payload = {
        orderState: this.orderStates.codes.REFUND,
        customerOrderId: this.customerOrder.id,
      };
      this.httpRequestInProgress = true;
      this.modalState = false;
      // guarantees a minium delay of 750ms or longer, if request takes longer. The animation looks very consistent thereby.
      //NICE very cool trick, gotta remember this one
      Promise.all([
        axios.post("/customerorder/action/refund", payload), // TODO url and logic
        new Promise((r) => setTimeout(r, 750)),
      ])
        .then(() => {
          // let clone = _.deepClone(this.customerOrder);
          // clone.orderState = this.orderStates.codes.WAIT;
          this.$emit("mutatedOrderState", this.orderStates.codes.REFUND);
          this.httpRequestInProgress = false;
					if(this.isOrderResponseAction && this.shouldCreateVendorCancellation){
						this.httpRequestInProgress = true;
						useCustomerOrderActions().createVendorCancellation(this.customerOrder).then(() => {
							this.$emit("success");
							this.httpRequestInProgress = false;
						}).catch((error) => {
							this.modalError = {
								show: true,
								message: "Fehler beim Erstellen des Händlerstornos.",
								error: error?.response?.data?.message ?? error,
								title: "Händler Storno",
							};
							console.error(error);
							this.httpRequestInProgress = false;
						});
					} else if(this.isOrderResponseAction){
						this.$emit("success");
					}
        })
        .catch((error) => {
          this.modalError = {
						show: true,
						message: "Konnte Bestellung nicht erstatten.",
						error: error?.response?.data?.message ?? error,
						title: "Bestellung Erstatten",
					};
          console.error(error);
					this.httpRequestInProgress = false;
        });
    },
  },
};
</script>
